import React, {
	forwardRef,
	RefObject,
	useCallback,
	useEffect,
	useImperativeHandle,
	useRef,
	useState,
} from "react";

import "reactflow/dist/style.css";
import DiamondNode from "./DiomondNode";
import ProcessNode from "./ProcessNode";
import smsNode from "./SMSNode";
import emailNode from "./EmailNode";
import reportPDFNode from "./reportPDFNode";
import { makeStyles } from "@material-ui/core";

import axios from "axios";
import {
	getFlowFileDetails,
	getFlowFileDetailsByID,
} from "../../services/UserService";
import ReactFlow, {
	addEdge,
	Background,
	Controls,
	Edge,
	MiniMap,
	Node,
	Panel,
	ReactFlowProvider,
	useEdgesState,
	useNodesState,
	useReactFlow,
} from "reactflow";
import UserTablePopup from "../popupComp/UserTablePopup";
import DecisionTablePopup from "../popupComp/DecisionTablePopup";
import {
	EmailTypes,
	PDFTypes,
	SensorsTypes,
	SMSTypes,
	UsersTypes,
} from "../../Data";
import SaveDialog from "../popupComp/SaveDialog";
import RestoreById from "../popupComp/RestoreById";
import EmailTablePopup from "../popupComp/EmailTablePopup";
import SMSTablePopup from "../popupComp/SMSTablePopup";
import UserRoleDateTable, { UserRoleDataRowType } from "../popupComp/UserRoleDataTable";
import UserRoleTablePopup from "../popupComp/RecipientRoleTablePopup";
import { MobileNodeTypes } from "../popupComp/MobileDataTable";
import { CAPNodeTypes } from "../popupComp/CAPDataTable";
import MobileNode from "./MobileNode";
import CAPNode from "./CAPNode";
import LoadingScreen from "../loadingScreenComp/LoadingScreen";
import WhatsappNode from "./WhatsappNode";
import ViberNode from "./ViberNode";
import AlertDialog from "../popupComp/AlertDialog";
import MobileNotificationPopup, { ButtonsType } from "../popupComp/MobileNotificationPopup";
import RecipientRoleNode from "./RecipientRoleNode";
import UserRoleNode from "./UserRoleNode";
import RecipientRoleTablePopup from "../popupComp/RecipientRoleTablePopup";
import Earthquake, { EarthquakeTypes } from "./EarthquakeNode";
import EarthquakeNode from "./EarthquakeNode";

const nodeTypes = {
	diamond: DiamondNode,
	process: ProcessNode,
	pdfreport: reportPDFNode,
	sms: smsNode,
	email: emailNode,
	recipientRole: RecipientRoleNode,
	userRole: UserRoleNode,
	mobile: MobileNode,
	testMobile: MobileNode,
	activeMobile: MobileNode,
	cap: CAPNode,
	whatsapp: WhatsappNode,
	viber: ViberNode,
	earthquake: EarthquakeNode
};

const initialNodes: Node[] = [];
const initialEdges: Edge[] = [];

const useStyles = makeStyles((theme: { spacing: (arg0: number) => any }) => ({
	formControl: {
		margin: theme.spacing(1),
		minWidth: 10,
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},
	paper: {
		background: "#a4a9fc",
		color: "white",
	},
	input: {
		color: "red",
		backgroundColor: "rgba(255, 0, 0, 0.4)",
		"&:focus": {
			borderRadius: 4,
			borderColor: "rgba(255,255,255,0.2)",
			boxShadow: "0 0 0 0.2rem rgba(0,190,255,0.6)",
			background: "rgba(0,0,0,0)",
		},
	},

	customButton: {
		backgroundColor: "#0E73A9",
		fontSize: "5",
		fontWeight: "bold",
		width: "10vw",
		color: "white",
		"&:hover": {
			backgroundColor: "#a4a9fc",
		},
	},

	dividerWithMargin: {
		marginLeft: "10px",
		marginRight: "10px", // You can adjust the margin as per your requirements
	},
}));

export type WorkflowTypes = {
	name: RefObject<HTMLInputElement>;
	id: RefObject<HTMLInputElement>;
	department: RefObject<HTMLSelectElement>;
	hzType: RefObject<HTMLSelectElement>;
	warningType: RefObject<HTMLSelectElement>;
	workflowType: RefObject<HTMLSelectElement>;
	triggerType: RefObject<HTMLSelectElement>
	localization: RefObject<HTMLSelectElement>
};

export interface FlowDiagramRef {
	saveFun: () => void; // Exposed method for parent
}

interface Props {
	list: WorkflowTypes[];
	hazardType: string;
	flowId: string;
}

let flowDetails: string = "";
//let warningiID: string = "";
let flowDetailsByID: string = "";

type WhatsappNodeTypes = {
	id: string;
	name: string;
}

type ViberNodeTypes = {
	id: string;
	name: string;
}

const FlowDiagram = forwardRef<FlowDiagramRef, Props>((props, ref) => {

	const BASE_URL = process.env.REACT_APP_BASE_URL
	const COUNTRY = process.env.REACT_APP_COUNTRY

	const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
	const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

	const [warningId, setWarningId] = useState<string>("")

	const [flowData, setFlowData] = useState("");
	const [flowDataByID, setFlowDataByID] = useState("");
	const [restoreID, setRestoreID] = React.useState("");

	const [isUserPopupOpen, setIsUserPopupOpen] = useState<boolean>(false);
	const [isRecipientRolePopupOpen, setIsRecipientRolePopupOpen] = useState<boolean>(false);
	const [isUserRolePopupOpen, setIsUserRolePopupOpen] = useState<boolean>(false);
	const [isDecisionPopupOpen, setIsDecisionPopupOpen] = useState<boolean>(false);
	// const [isPDFPopupOpen, setIsPDFPopupOpen] = useState<boolean>(false);
	// const [isSMSPopupOpen, setIsSMSPopupOpen] = useState<boolean>(false);
	// const [isEmailPopupOpen, setIsEmailPopupOpen] = useState<boolean>(false);
	// const [isMobilePopupOpen, setIsMobilePopupOpen] = useState<boolean>(false);
	// const [isCAPPopupOpen, setIsCAPPopupOpen] = useState<boolean>(false);
	const [isEarthquakePopupOpen, setIsEarthquakePopupOpen] = useState<boolean>(false)

	const [isMobileNotificationPopupOpen, setIsMobileNotificationPopupOpen] = useState<boolean>(false);

	const [isSaveDialogOpen, setIsSaveDialogOpen] = useState<boolean>(false);
	const [isRestoreByIdOpen, setIsRestoreByIdOpen] = useState<boolean>(false);

	const { setViewport } = useReactFlow();

	const [alertDialogState, setAlertDialogState] = useState(false);
	const [alertTitle, setAlertTitle] = useState('');
	const [alertDescription, setAlertDescription] = useState('');
	const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
	const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK

	const showAlertDialog = (title: string, description: string, yesCallback?: () => void, okCallback?: () => void ) => {
		setAlertTitle(title);
		setAlertDescription(description);
		setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
		setAlertOkCallback(() => okCallback);   // Will trigger only on OK
		setAlertDialogState(true);
	};

	// Loading screen
	const [isLoading, setIsLoading] = useState<boolean>(false);

	useEffect(() => {
		props.list.map((data) => {
			setWarningId(data.id.current?.value ?? "")
		});
		sessionStorage.setItem('proc_id', warningId);
	}, [props.list]);

	useEffect(() => {
		const handleBeforeUnload = () => {
			sessionStorage.removeItem('proc_id');
		};

		window.addEventListener("beforeunload", handleBeforeUnload);

		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, []);

	const uploadFlowFileData = (selectedFile: File, name: string) => {
		const formData = new FormData();
		formData.append("file", selectedFile, name);
		const token = localStorage.getItem("access_token");

		axios
			.post(`${BASE_URL}/workflow_engine/api/v1/uploadflowfile`, formData, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "multipart/form-data",
				},
			})
			.then((response) => {
				console.log(response.data);
				showAlertDialog("Success", "✅ Workflow saved successfully!");
			})
			.catch((error) => {
				console.error("Error uploading file: ", error);
			})
			.finally(() => {
				setIsLoading(false)
				
			})
	};

	function exportFlowchartInfo(flowInfo: string) {
		const fileData = JSON.stringify(flowInfo);
		const blob = new Blob([fileData], { type: "text/plain" });
		const url = URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.download = "flowchart-info.txt";
		link.href = url;

		//document.body.appendChild(link)
		//link.click()
		//document.body.removeChild(link)

		//URL.revokeObjectURL(url)
		uploadFlowFileData(blob as File, warningId);
	}

	const onSave = useCallback(() => {
		setIsLoading(true)
		const flow = {
			nodes: nodes,
			edges: edges,
			viewport: { x: 0, y: 0, zoom: 1 },
		};
		exportFlowchartInfo(JSON.stringify(flow));
	}, [nodes, edges]);

	const editFlow = useCallback(() => {
		const unquotedflowDetails = flowDetails.substring(
			1,
			flowDetails.length - 1
		);

		const restoreFlow = async () => {
			if (unquotedflowDetails) {
				const flow = JSON.parse(unquotedflowDetails);
				const { x = 0, y = 0, zoom = 1 } = flow.viewport;
				setNodes(flow.nodes || []);
				setEdges(flow.edges || []);
				setViewport({ x, y, zoom });
			}
		};

		restoreFlow();
	}, [setNodes, setEdges, setViewport])

	useEffect(() => {
		//console.log("FLOW DATA -> ", flowData)
		if (flowData === "")
		{
			setNodes([]);
			setEdges([]);
		}
		else 
		{
			editFlow()
		}
	}, [flowData])


	// Expose methods to parent
	useImperativeHandle(ref, () => ({
		saveFun: onSave, // expose the onSave method
	}));

	//----------------------Process Node Adding Function-------------------------------
	const addNodeProcess = useCallback(
		(selectedData: UsersTypes[]) => {
			let tempNodes: Node<any, string | undefined>[] = nodes;
			selectedData.forEach((selected) => {
				const location = Math.random() * 500;
				const tempNode: Node = {
					id: `pro${tempNodes.length + 1}`,
					data: { label: `${selected.username}`, data: selected as UsersTypes},
					position: { x: location, y: location },
					type: "process",
				};
				tempNodes = [...tempNodes, tempNode];
			});
			setNodes(tempNodes);
		},
		[nodes]
	);

	//----------------------Decision Node Adding Function-------------------------------
	const addNodeDecision = useCallback((selectedData: SensorsTypes[]) => {
			let tempNodes: Node<any, string | undefined>[] = nodes;
			selectedData.forEach((sen) => {
				const location = Math.random() * 500;
				const tempNode: Node = {
					id: `dmn${tempNodes.length + 1}`,
					data: { label: `${sen.sensorName}`, data: sen },
					position: { x: location, y: location },
					type: "diamond",
				};
				tempNodes = [...tempNodes, tempNode];
			});
			setNodes(tempNodes);
		},
		[nodes]
	);

	const addNodeEarthquake = useCallback((selectedData: EarthquakeTypes[]) => {
		let tempNodes: Node<any, string | undefined>[] = nodes;
		selectedData.forEach((sen) => {
			const location = Math.random() * 500;
			const tempNode: Node = {
				id: `eq${tempNodes.length + 1}`,
				data: { label: `${sen.nodeId}`, data: sen },
				position: { x: location, y: location },
				type: "earthquake",
			};
			tempNodes = [...tempNodes, tempNode];
		});
		setNodes(tempNodes);
		setIsEarthquakePopupOpen(false)
	},
	[nodes]
);

	//----------------------PDF Node Adding Function-------------------------------
	const addReportPDFNode = useCallback(
		(selectedData: PDFTypes[]) => {
			let tempNodes: Node<any, string | undefined>[] = nodes;
			selectedData.forEach((pdf) => {
				const location = Math.random() * 500;
				const tempNode: Node = {
					id: `pdf${tempNodes.length + 1}`,
					data: { label: `${'PDF'}`, data: pdf },
					position: { x: location, y: location },
					type: "pdfreport",
				};
				tempNodes = [...tempNodes, tempNode];
			});
			setNodes(tempNodes);
		},
		[nodes]
	);

	//----------------------SMS Node Adding Function-------------------------------

	const addSMSNode = useCallback(
		(selectedData: SMSTypes[]) => {
			let tempNodes: Node<any, string | undefined>[] = nodes;
			selectedData.forEach((sms) => {
				const location = Math.random() * 500;
				const tempNode: Node = {
					id: `sms${tempNodes.length + 1}`,
					data: { label: `${'SMS'}`, data: sms },
					position: { x: location, y: location },
					type: "sms",
				};
				tempNodes = [...tempNodes, tempNode];
			});
			setNodes(tempNodes);
		},
		[nodes]
	);

	//----------------------Email Node Adding Function-------------------------------

	const addEmailNode = useCallback(
		(selectedData: EmailTypes[]) => {
			let tempNodes: Node<any, string | undefined>[] = nodes;
			selectedData.forEach((email) => {
				const location = Math.random() * 500;
				const tempNode: Node = {
					id: `email${tempNodes.length + 1}`,
					data: { label: `${'email'}`, data: email },
					position: { x: location, y: location },
					type: "email",
				};
				tempNodes = [...tempNodes, tempNode];
			});
			//console.log("Entered: ", tempNodes)
			setNodes(tempNodes);
		},
		[nodes]
	)

	// ------------------- New Node ------------------------
	const addUserRoleNode = useCallback((selectedData: UserRoleDataRowType[]) => {
		let tempNodes: Node<any, string | undefined>[] = nodes
		selectedData.forEach((role) => {
			const location = Math.random() * 500
			const tempNode: Node = {
				id: `userRole${tempNodes.length + 1}`,
				data: { label: `${role.id}`, data: role },
				position: { x: location, y: location },
				type: "userRole",
			}
			tempNodes = [...tempNodes, tempNode]
		})
		//console.log("Entered: ", tempNodes)
		setNodes(tempNodes)
		}, [nodes]
	)

	const addRecipientRoleNode = useCallback((selectedData: UserRoleDataRowType[]) => {
		let tempNodes: Node<any, string | undefined>[] = nodes
		selectedData.forEach((role) => {
			const location = Math.random() * 500
			const tempNode: Node = {
				id: `recipientRole${tempNodes.length + 1}`,
				data: { label: `${role.id}`, data: role },
				position: { x: location, y: location },
				type: "recipientRole",
			}
			tempNodes = [...tempNodes, tempNode]
		})
		//console.log("Entered: ", tempNodes)
		setNodes(tempNodes)
		}, [nodes]
	)

	const addNodeMobile = useCallback(
		(selectedData: MobileNodeTypes[]) => {
			let tempNodes: Node<any, string | undefined>[] = nodes;
			
			selectedData.forEach((selected) => {
				const location = Math.random() * 500;
				const tempNode: Node = {
					id: `mobile${tempNodes.length + 1}`,
					data: { label: `${'activeMobile'}`, data: selected},
					position: { x: location, y: location },
					type: "mobile",
				};
				tempNodes = [...tempNodes, tempNode];
			});
			setNodes(tempNodes);
		},
		[nodes]
	);

	const addNodeTestMobile = useCallback((selectedData: MobileNodeTypes[]) => {
		let tempNodes: Node<any, string | undefined>[] = nodes;
		
		selectedData.forEach((selected) => {
			const location = Math.random() * 500;
			const tempNode: Node = {
				id: `testMobile${tempNodes.length + 1}`,
				data: { label: `${'testMobile'}`, data: selected},
				position: { x: location, y: location },
				type: "testMobile",
			};
			tempNodes = [...tempNodes, tempNode];
		});
		setNodes(tempNodes);
		setIsMobileNotificationPopupOpen(false)
	}, [nodes]);

	const addNodeActiveMobile = useCallback((selectedData: MobileNodeTypes[]) => {
		let tempNodes: Node<any, string | undefined>[] = nodes;
		
		selectedData.forEach((selected) => {
			const location = Math.random() * 500;
			const tempNode: Node = {
				id: `activeMobile${tempNodes.length + 1}`,
				data: { label: `${'activeMobile'}`, data: selected},
				position: { x: location, y: location },
				type: "activeMobile",
			};
			tempNodes = [...tempNodes, tempNode];
		});
		setNodes(tempNodes);
		setIsMobileNotificationPopupOpen(false)
	},
	[nodes]
);

	const addNodeWhatsapp = useCallback(
		(selectedData: WhatsappNodeTypes[]) => {
			let tempNodes: Node<any, string | undefined>[] = nodes;
			
			selectedData.forEach((selected) => {
				const location = Math.random() * 500;
				const tempNode: Node = {
					id: `whatsapp${tempNodes.length + 1}`,
					data: { label: `${'whatsapp'}`, data: selected},
					position: { x: location, y: location },
					type: "whatsapp",
				};
				tempNodes = [...tempNodes, tempNode];
			});
			setNodes(tempNodes);
		},
		[nodes]
	);

	const addNodeViber = useCallback(
		(selectedData: ViberNodeTypes[]) => {
			let tempNodes: Node<any, string | undefined>[] = nodes;
			
			selectedData.forEach((selected) => {
				const location = Math.random() * 500;
				const tempNode: Node = {
					id: `viber${tempNodes.length + 1}`,
					data: { label: `${'Viber'}`, data: selected},
					position: { x: location, y: location },
					type: "viber",
				};
				tempNodes = [...tempNodes, tempNode];
			});
			setNodes(tempNodes);
		},
		[nodes]
	);

	const addCAPNode = useCallback(
		(selectedData: CAPNodeTypes[]) => {
			let tempNodes: Node<any, string | undefined>[] = nodes;
			selectedData.forEach((selected) => {
				const location = Math.random() * 500;
				const tempNode: Node = {
					id: `cap${tempNodes.length + 1}`,
					data: { label: `${'CAP'}` },
					position: { x: location, y: location },
					type: "cap",
				};
				tempNodes = [...tempNodes, tempNode];
			});
			setNodes(tempNodes);
		},
		[nodes]
	);

	// -----------------------------------

	const onConnect = useCallback(
		(params: any) => setEdges((eds) => addEdge(params, eds)),
		[setEdges]
	);

	//-------------------editFlow Part--------------------------------

	const getFlowFile = (userid: string) => {
		getFlowFileDetails(userid)
			.then((response: any) => {
				setFlowData(response.data);
			})
			.catch((error: any) => {
				console.log(error);
			});
	};

	if (warningId != "") {
		getFlowFile(warningId);
		flowDetails = flowData;
	}

	//-------------------restoreByID Part--------------------------------
	const receivedData = useRef<any>();

	const getFlowFileByID = (warningid: string) => {
		getFlowFileDetailsByID(warningid)
			.then((response: any) => {
				receivedData.current = response.data;
				const data = receivedData.current.substring(
					1,
					receivedData.current.length - 1
				);
				const dataFixed = JSON.parse(data);
				setNodes(dataFixed.nodes);
				setEdges(dataFixed.edges);

				//setFlowDataByID(response.data);
				//console.log(response.data)
			})
			.catch((error: any) => {
				console.log(error);
			});
	};

	if (restoreID != "") {
		getFlowFileByID(restoreID);
		flowDetailsByID = flowDataByID;
	}

	const restoreByID = useCallback(
		(restoreID: string) => {
			getFlowFileByID(restoreID);
		},
		[setNodes, setEdges, setViewport]
	)

	useEffect(() => {
		if (props.hazardType === 'EQW' && (nodes.length === 0 || nodes === undefined))
		{
			const data: EarthquakeTypes = {
				flowId: props.flowId,
				nodeId: 'system_user',
				nodeName: 'Earthquake',
				minDepth: 5,
				maxDepth: 10,
				minMagnitude: 5,
				maxMagnitude: 10,
				location: null
			}

			const dataList: EarthquakeTypes[] = []
			dataList.push(data)

			addNodeEarthquake(dataList)
		}
		else
		{
			//setIsEarthquakePopupOpen(false)
		}
		//console.log("HAZARD TYPE ->", props.hazardType)
	}, [props.hazardType, nodes])

	return (
		<div className={`canvas-wrapper`}>
			<div className={`menu-container`}>
				<div className={`top`}>
					{ COUNTRY === 'MALDIVES' || COUNTRY === 'SRI_LANKA' && (
						<button className="popup-btn" onClick={(e) => setIsUserPopupOpen(true)}>User</button>
					) }
					{ COUNTRY === 'MALDIVES' || COUNTRY === 'SRI_LANKA' && (
						<button className="popup-btn" onClick={(e) => setIsRecipientRolePopupOpen(true)}>Recipient Role</button>
					) }
					{ COUNTRY === 'MALDIVES' || COUNTRY === 'SRI_LANKA' && (
						<button className="popup-btn" onClick={(e) => setIsUserRolePopupOpen(true)}>User Role</button>
					) }
					{ COUNTRY === 'SRI_LANKA' && (
						<button className="popup-btn" onClick={(e) => setIsDecisionPopupOpen(true)}>Sensors</button>
					) }
					{ COUNTRY === 'SRI_LANKA' && (
						<button className="popup-btn" onClick={(e) => addReportPDFNode([{id: "pdf-id-1", pdftype: "pdf", hazardtype: "LSW"}])}>PDF Report</button>
					) }
					{ COUNTRY === 'MALDIVES' || COUNTRY === 'SRI_LANKA' && (
						<button className="popup-btn" onClick={(e) => addSMSNode([{id: "whatsapp-id-1", smstype: "sms", hazardtype: "lsw"}])}>SMS</button>
					) }
					{ COUNTRY === 'MALDIVES' || COUNTRY === 'SRI_LANKA' && (
						<button className="popup-btn" onClick={(e) => addNodeWhatsapp([{id: "whatsapp-id-1", name: "Whatsapp"}])}>Whatsapp</button>
					) }
					{ COUNTRY === 'MALDIVES' || COUNTRY === 'SRI_LANKA' && (
						<button className="popup-btn" onClick={(e) => addNodeViber([{id: "viber-id-1", name: "viber"}])}>Viber</button>
					) }
					{ COUNTRY === 'MALDIVES' || COUNTRY === 'SRI_LANKA' && (
						<button className="popup-btn" onClick={(e) => addEmailNode([{id: "email-id-1", emailtype: "email", hazardtype: "lsw"}])}>Email</button>
					) }
					{ COUNTRY === 'MALDIVES' || COUNTRY === 'SRI_LANKA' && (
						<button className="popup-btn" onClick={(e) => setIsMobileNotificationPopupOpen(true)}>Mobile Notifications</button>
					) }
					{COUNTRY === 'MALDIVES' || COUNTRY === 'SRI_LANKA' && (
						<button className="popup-btn" onClick={(e) => addCAPNode([{id: 'cap-id1', name: 'cap'}])}>CAP</button>
					) }
					
					
					
					{/* <button className="popup-btn" onClick={(e) => addNodeMobile([{id: "mobile-id-1", name: "notification"}])}>Mobile Notifications</button> */}
					
					
					{/* <button className="popup-btn" onClick={(e) => setIsEarthquakePopupOpen(true)}>Earthquake</button> */}
				</div>
				<div className={`bottom`}>
					<button className="save-btn" onClick={(e) => {
						showAlertDialog(
                            "Confirm Submit",
                            "Are you sure you want to save this workflow?",
                            () => onSave(), undefined)
					}}>Save</button>
					<button className="restore-btn" onClick={editFlow}>Restore</button>
					{/* <button className="restore-btn" onClick={(e) => setIsRestoreByIdOpen(true)}>Restore By ID</button> */}
				</div>
			</div>
			<div className={`flow-wrapper`}>
				<ReactFlow
					nodes={nodes}
					edges={edges}
					onNodesChange={onNodesChange}
					onEdgesChange={onEdgesChange}
					onConnect={onConnect}
					nodeTypes={nodeTypes}
					proOptions={{ hideAttribution: true }}
				>
					<Background />
					<Controls />
					<MiniMap
						nodeColor={(n) => (n.type === "input" ? "blue" : "#FFCC00")}
						style={{
							backgroundColor: "color-mix(in oklab, var(--color-main-black), white var(--value-side-menu-mix))",
						}}
					/>
				</ReactFlow>
			</div>

			{isUserPopupOpen && (
				<UserTablePopup
					title="adding users table"
					windowState={isUserPopupOpen}
					setWindowState={setIsUserPopupOpen}
					function={addNodeProcess}
					hazardType={props.list[0]?.hzType.current?.value || ""}
				/>
			)}

			{isRecipientRolePopupOpen && (
				<RecipientRoleTablePopup 
					title="adding user role" 
					windowState={isRecipientRolePopupOpen} 
					setWindowState={setIsRecipientRolePopupOpen} 
					function={addRecipientRoleNode} 
					hazardType={props.list[0]?.hzType.current?.value || ""} 
				/>
			)}

			{isUserRolePopupOpen && (
				<UserRoleTablePopup 
					title="adding user role" 
					windowState={isUserRolePopupOpen} 
					setWindowState={setIsUserRolePopupOpen} 
					function={addUserRoleNode} 
					hazardType={props.list[0]?.hzType.current?.value || ""} 
				/>
			)}

			{isDecisionPopupOpen && (
				<DecisionTablePopup
					title="adding sensors table"
					windowState={isDecisionPopupOpen}
					setWindowState={setIsDecisionPopupOpen}
					function={addNodeDecision}
					hazardType={props.list[0]?.hzType.current?.value || ""}
				/>
			)}

			{/* {isPDFPopupOpen && (
				<PDFTablePopup
					title="adding PDF report node"
					windowState={isPDFPopupOpen}
					setWindowState={setIsPDFPopupOpen}
					function={addReportPDFNode}
					hazardType={props.list[0]?.hzType.current?.value || ""}
				/>
			)} */}

			{/* {isSMSPopupOpen && (
				<SMSTablePopup
					title="adding SMS node"
					windowState={isSMSPopupOpen}
					setWindowState={setIsSMSPopupOpen}
					function={addSMSNode}
					hazardType={props.list[0]?.hzType.current?.value || ""}
				/>
			)} */}

			{/* {isEmailPopupOpen && (
				<EmailTablePopup
					title="adding email nodes"
					windowState={isEmailPopupOpen}
					setWindowState={setIsEmailPopupOpen}
					function={addEmailNode}
					hazardType={props.list[0]?.hzType.current?.value || ""}
				/>
			)} */}

			{/* {isMobilePopupOpen && (
				<MobileTablePopup
					title="adding mobile"
					windowState={isMobilePopupOpen}
					setWindowState={setIsMobilePopupOpen}
					function={addNodeMobile}
					hazardType={props.list[0]?.hzType.current?.value || ""}
				/>
			)} */}

			{/* {isCAPPopupOpen && (
				<CAPTablePopup
					title="adding common alert protocol (CAP)"
					windowState={isCAPPopupOpen}
					setWindowState={setIsCAPPopupOpen}
					function={addCAPNode}
					hazardType={props.list[0]?.hzType.current?.value || ""}
				/>
			)} */}

			{isMobileNotificationPopupOpen && (
				<MobileNotificationPopup addTestFunction={addNodeTestMobile} addActiveFunction={addNodeActiveMobile} setState={setIsMobileNotificationPopupOpen} />
			)}

			{/* {isEarthquakePopupOpen && (
				<EarthquakeTablePopup
					title="adding earthquake"
					windowState={isEarthquakePopupOpen}
					setWindowState={setIsEarthquakePopupOpen}
					function={addNodeEarthquake}
					flowId={props.flowId}
				/>
			)} */}

			{isSaveDialogOpen && (
				<SaveDialog
					title="save"
					windowState={isSaveDialogOpen}
					setWindowState={setIsSaveDialogOpen}
					function={onSave}
				/>
			)}

			{isRestoreByIdOpen && (
				<RestoreById
					setWindowState={setIsRestoreByIdOpen}
					function={restoreByID}
				/>
			)}
			{isLoading && (
				<LoadingScreen />
			)}

			{alertDialogState && (
				<AlertDialog
					title={alertTitle}
					description={alertDescription}
					windowState={alertDialogState}
					setWindowState={setAlertDialogState}
					function={alertYesCallback}
					okFunction={alertOkCallback}
				/>
			)}
		</div>
	);
});

// export default FlowDiagram;
const FlowDiagramWrapper = forwardRef<FlowDiagramRef, Props>((props, ref) => (
	<ReactFlowProvider>
	  <FlowDiagram {...props} ref={ref} />
	</ReactFlowProvider>
));

export default FlowDiagramWrapper;